import React from 'react';
import styles from '../styles.scss';

export interface BadgeProps {
  color: string;
}

export const ChartKey: React.FC<BadgeProps> = ({ color }) => (
  <div className={styles.badge} style={{ backgroundColor: color }} />
);
